// Actions for FencesContainer UI state
export const SET_GEOFENCE_CONTAINER_SHOW = 'SET_GEOFENCE_CONTAINER_SHOW';
export const TOGGLE_GEOFENCE_CONTAINER_SHOW = 'TOGGLE_GEOFENCE_CONTAINER_SHOW';

export const setGeoFenceContainerShow = (isGeoFenceContainerVisible: boolean) => ({
    type: SET_GEOFENCE_CONTAINER_SHOW,
    isGeoFenceContainerVisible,
});

export const toggleGeoFenceContainerShow = () => ({
    type: TOGGLE_GEOFENCE_CONTAINER_SHOW,
});
